// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCssJs$PrezzeeRibbon from "../bindings/BsCss/BsCssJs.bs.js";

var borderRadius = BsCssJs$PrezzeeRibbon.px(10);

var Personal = {
  borderRadius: borderRadius
};

var borderRadius$1 = BsCssJs$PrezzeeRibbon.px(4);

var Business = {
  borderRadius: borderRadius$1
};

export {
  Personal ,
  Business ,
}
/* borderRadius Not a pure module */
